import { handleChunkLoadError } from '@hydra/utils/handleChunkLoadError';

export default ({
  path: '',
  children: [
    {
      path: 'review/:url',
      async getComponent () {
        const {
          default: ReviewContainer
        } = await import(/* webpackChunkName: "review-container" */ './components/ReviewContainer')
          .catch(handleChunkLoadError);
        return ReviewContainer;
      },
      getData: ({ context: { props } }) => props || {}
    },
    {
      path: 'project-review/:url',
      async getComponent () {
        const {
          default: ReviewContainer
        } = await import(/* webpackChunkName: "project-review-container" */ './components/ReviewContainer')
          .catch(handleChunkLoadError);
        return ReviewContainer;
      },
      getData: ({ context: { props } }) => props || {}
    },
    {
      path: 'www/:url',
      async getComponent () {
        const {
          default: ReviewContainer
        } = await import(/* webpackChunkName: "free-review-container" */ './components/FreeReviewContainer')
          .catch(handleChunkLoadError);
        return ReviewContainer;
      },
      getData: ({ context: { props } }) => props || {}
    },
    {
      path: 'teaser-review/:url',
      async getComponent () {
        const {
          default: ReviewContainer
        } = await import(/* webpackChunkName: "free-review-container" */ './components/TeaserReviewContainer')
          .catch(handleChunkLoadError);
        return ReviewContainer;
      },
      getData: ({ context: { props } }) => props || {}
    }
  ]
});
